<template>
  <button
    class="group flex w-full items-center gap-x-1"
    @click="emits('setSorting', header.id)"
  >
    <span :class="[header.id === vmSortField && 'text-default']">{{ header.column.columnDef.header }}</span>
    <FontAwesomeIcon
      v-if="header.id === vmSortField"
      :name="arrowIcon"
      class="text-default"
    />
    <FontAwesomeIcon
      v-else
      name="sort"
      class="text-default"
    />
  </button>
</template>

<script setup lang="ts" generic="T">
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import type { Header } from '@tanstack/vue-table'
import { useVModel } from '@vueuse/core'

import { sortDirectionType } from '~/ui/Table/types'

interface IProps {
  header: Header<T, unknown>
  sortDirection: sortDirectionType
  sortField: string
}

const props = defineProps<IProps>()
const vmSortDirection = useVModel(props, 'sortDirection')
const vmSortField = useVModel(props, 'sortField')

const emits = defineEmits([ 'setSorting' ])

const arrowIcon = computed(() => {
  return vmSortDirection.value === sortDirectionType.ASC ? 'sort-up' : 'sort-down'
})
</script>

<style lang="sass" scoped>

</style>